module.exports = [
  {
    id: '1',
    title: '1.Focus Mode',
    description: "Here, geometric transformations visually represent the timer's progress, offering a unique way to track time as it flows.",
    img: require('../assets/hourglass-focus.png'),
  },
  {
    id: '2',
    title: '2.Clock Mode',
    description: 'In this setting, geometric transformations act as the second hand of the clock, providing a mesmerizing, continuous motion that keeps time in an artistic manner.',
    img: require('../assets/hourglass-clock.png'),
  },
  {
    id: '3',
    title: '3.Art Mode',
    description: 'This mode allows geometric transformations to loop endlessly, turning the device into a standalone piece of digital art, perfect for adding a touch of beauty to any space.',
    img: require('../assets/hourglass-art.png'),
  },
]
